import React from "react";
import { BaseDistributorLogoProps } from "./DistributorLogo";
import DistributorLogoThemes from "./DistributorLogoThemes";
import { addStaticRootToUrl } from "@src/utils/static";

/** Path to logo in Django static files */
const MIDWEST_LOGO_PATH = addStaticRootToUrl("images/midwest-logo.png");

/** Maximum width for the Midwest logo to maintain visual consistency with other distributor logos */
const MAX_WIDTH = 100;

/** Original image dimensions for aspect ratio calculation */
const ORIGINAL_WIDTH = 736;
const ORIGINAL_HEIGHT = 178;
const ASPECT_RATIO = ORIGINAL_WIDTH / ORIGINAL_HEIGHT;

/**
 * Renders the Midwest Veterinary Supply logo.
 * Uses a PNG image from Django static files (unlike other distributors that use inline SVGs)
 * because Midwest only provides a PNG logo.
 */
export default function MidwestVeterinarySupplyLogo({
  className,
  width,
  height = 24,
  theme,
}: BaseDistributorLogoProps): React.JSX.Element {
  if (theme !== DistributorLogoThemes.Default) {
    return (
      <span className="text-xs text-error">
        Distributor logo theme '{theme}' not supported
      </span>
    );
  }

  // Calculate width from height if not provided, maintaining aspect ratio but capped at MAX_WIDTH
  const calculatedWidth =
    width ?? Math.min(MAX_WIDTH, Math.round(height * ASPECT_RATIO));

  return (
    <img
      className={className}
      src={MIDWEST_LOGO_PATH}
      alt="Midwest Veterinary Supply"
      width={calculatedWidth}
      height={height}
      style={{ objectFit: "contain" }}
    />
  );
}
